/**
 * Rank user-tag suggestions for autocomplete (#238): contains-match, prefix hits first,
 * then alphabetical. Already-applied tags are excluded. Returns at most `limit` entries.
 * An empty query yields no suggestions (suggest only while typing).
 */
export function rankTagSuggestions(
  all: string[],
  query: string,
  exclude: string[] = [],
  limit = 8,
): string[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  const excluded = new Set(exclude);
  return all
    .filter((t) => !excluded.has(t) && t.toLowerCase().includes(q))
    .sort((a, b) => {
      const aPrefix = a.toLowerCase().startsWith(q) ? 0 : 1;
      const bPrefix = b.toLowerCase().startsWith(q) ? 0 : 1;
      if (aPrefix !== bPrefix) return aPrefix - bPrefix;
      return a.localeCompare(b);
    })
    .slice(0, limit);
}
